import React, { useContext } from 'react';
import { GlobalDataContext, TemplateContext, evaluateTemplateValue } from "@ea-lab/reactive-json";

const PageHeader = ({ props }) => {
  const globalDataContext = useContext(GlobalDataContext);
  const templateContext = useContext(TemplateContext);

  const pageTitle = evaluateTemplateValue({
      valueToEvaluate: props.pageTitle,
      globalDataContext,
      templateContext
  }) || 'Projet';

  const currentUserRole = evaluateTemplateValue({
      valueToEvaluate: props.currentUserRole,
      globalDataContext,
      templateContext
  });

  const roles = evaluateTemplateValue({
      valueToEvaluate: props.roles,
      globalDataContext,
      templateContext
  }) || [];

  const handleRoleChange = (e) => {
    const newRole = e.target.value;
    if (globalDataContext.updateData) {
      globalDataContext.updateData(newRole, "currentUserRole");
    } else if (globalDataContext.setData) {
       const currentData = { ...globalDataContext.data };
       currentData.currentUserRole = newRole;
       globalDataContext.setData(currentData);
    }
  };

  return (
    <div className="bg-white border-b border-slate-200 px-6 py-4 flex items-center justify-between">
      {/* Left Side */}
      <div className="flex items-center gap-4">
        <div>
          <button 
            className="btn btn-primary flex items-center gap-2"
            onClick={() => console.log('Nouveau projet clicked')}
          >
            <span className="font-bold text-lg leading-none pb-1">+</span>
            <span>Nouveau projet</span>
          </button>
        </div>
        
        <div>
          <div className="flex items-center gap-2">
            <span className="font-bold text-slate-900 text-lg">{pageTitle}</span>
          </div>
        </div>
      </div>

      {/* Right Side */}
      <div className="flex items-center gap-4">
          {roles && roles.length > 0 && (
            <div className="flex items-center gap-2">
              <label htmlFor="role-select-ph" className="text-sm font-medium text-slate-700">En tant que :</label>
              <select
                id="role-select-ph"
                value={currentUserRole || ''}
                onChange={handleRoleChange}
                className="block rounded-md border-0 py-1.5 pl-3 pr-10 text-slate-900 ring-1 ring-inset ring-slate-300 focus:ring-2 focus:ring-iris-600 sm:text-sm sm:leading-6"
              >
                {roles.map((role) => (
                  <option key={role} value={role}>{role}</option>
                ))}
              </select>
            </div>
          )}
      </div>

    </div>
  );
};

export default PageHeader;
